export default __webpack_public_path__ + "images/9d32eae80bcc091e7d8e2dc6ec2b7f57-animalwelfare.webp";